import { render, staticRenderFns } from "./HistoricalAlarmType.vue?vue&type=template&id=4475a60a&scoped=true&"
import script from "./HistoricalAlarmType.vue?vue&type=script&lang=js&"
export * from "./HistoricalAlarmType.vue?vue&type=script&lang=js&"
import style0 from "./HistoricalAlarmType.vue?vue&type=style&index=0&id=4475a60a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4475a60a",
  null
  
)

export default component.exports